import React from "react";
import { useTranslation } from "react-i18next";

function RateUsPageTitle() {
  const { t, i18n } = useTranslation();

  return (
    <>
      <>
        {/* Page Title */}
        <div className="page-title">
          <div className="heading">
            <div className="container">
              <div className="row d-flex justify-content-center text-center">
                <div className="col-lg-8">
                  <h1 className="text-white">{t("rateUsTitle")}</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* End Page Title */}
      </>
    </>
  );
}

export default RateUsPageTitle;
